export class Feature {
    ID: number;
    Name: string;
}

export default Feature;